import type { FaireProductEntity } from "../../entity_types/product";

export const p_6zvcyk4d36: FaireProductEntity = {
  token: "p_6zvcyk4d36",
  type: "product",
  name: "Plaid Shacket Button Down Oversized Pocket Jacket",
  brandToken: "b_t9mynp4xpd",
  brandName: "Lovesoft",
  imageUrl:
    "https://cdn.faire.com/fastly/a5233eb58ecb0c21e0db290c5d36b3414db775e8bf5b3f4e2750674410e03bb0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1f0abe976430f495765aa72ec0295ce2132ef7f62d71e930fd54e23d43bf763a.jpeg",
    "https://cdn.faire.com/fastly/8f96d69a349fce9ea6884929b003d5a3348af0f03c566ce3b03facb4cfb31003.jpeg",
    "https://cdn.faire.com/fastly/cc69c0f1a15e237b3b8fc7748164b27297bb44211387996a0b53c7ca2466a270.jpeg",
  ],
  priceDollars: 80.12,
  description:
    "A must-have layering piece for fall and winter. This plaid shacket blends the structure of a jacket with the comfort of a shirt, making it a staple for boutique collections.\n\n• Classic plaid design\nTimeless plaid pattern adds a trendy yet versatile look that never goes out of style, perfect for seasonal displays.\n\n• Soft warm fabric\nCrafted from soft, cozy material that provides warmth without feeling bulky, ideal for chilly weather layering.\n\n• Button down shacket style\nFeatures a full button front for easy wear, combining the casual feel of a shirt with the coverage of a lightweight jacket.\n\n• Functional pocket detail\nDesigned with front pockets for added style and convenience, enhancing both practicality and fashion appeal.\n\n• Oversized relaxed fit\nLoose silhouette allows easy layering over tees, sweaters, or hoodies, making it perfect for everyday wear, travel, and casual outings.\n\nBrand labels are not included by default. If needed, please add them via this link ($0.50/pc): https://www.faire.com/product/p_kzks8vegvk\n \n",
  tags: [],
  msrpDollars: 160.24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:07.578Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
